




































import Vue from 'vue'

interface ComponentData {
  tree: any
  search: string | null
  selectedTreeItem: any | null
}

export default Vue.extend({
  name: 'EmployeeTreeFilterDialog',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: Array as () => any[]
  },

  data (): ComponentData {
    return {
      tree: [],
      search: '',
      selectedTreeItem: null
    }
  },

  computed: {
    filter () {
      return  undefined
    },

    isSaveDisabled (): boolean {
      if(!this.selectedTreeItem || (this.selectedTreeItem && this.selectedTreeItem.type !== 'A')) {
        return true
      } else {
        return false
      }
    }
  },

  watch: { },

  methods: {
    onChange (item: any): void {
      this.selectedTreeItem = item.length > 0 ? item[0] : null
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      this.$emit('save', this.selectedTreeItem)
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    }
  },

  mounted (): void {
    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
